import { FC, useEffect, useState } from 'react';

import { Input } from 'ui/components/form';
import { SIZE } from 'utils/constants';
import { cn } from 'utils/helpers';

interface PROPS {
  onChange: (e: any) => void;
  confirmationText?: string;
}

const CONFIRMATION = 'DELETE';

const DeleteValidation: FC<PROPS> = ({
  onChange,
  confirmationText = CONFIRMATION,
}) => {
  const [value, setValue] = useState<string>('');

  useEffect(() => {
    onChange(value === confirmationText);
  }, [confirmationText, onChange, value]);

  return (
    <div className="pt-4 space-y-2">
      <p className={cn('font-semibold text-sm', 'tracking-wider leading-6')}>
        Type "{confirmationText}" to confirm your action
      </p>
      <Input
        ref={(ref) => ref?.focus()}
        type="text"
        size={SIZE.Small}
        onChange={(e) => setValue(e.target.value)}
        value={value}
        required
      />
    </div>
  );
};

export default DeleteValidation;
